export default {
  data() {
    return {
      columns: [
        {
          title: '业务类型',
          dataIndex: 'name',
          disabled: true,
          width: '20%',
        },
        {
          title: 'Segment',
          dataIndex: 'segment',
          disabled: true,
        },
        {
          title: '账期(天)',
          dataIndex: 'term',
          disabled: true,
        },
        {
          title: '操作',
          fixed: 'right',
          width: 220,
          dataIndex: 'action',
          slotName: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
    }
  },
}
